import { createSlice } from '@reduxjs/toolkit'

const customerViewSlice = createSlice({
  name: 'tripShow',
  initialState: {
    data: {},
    detailPageData: {},
    imagesGalleryData: {},
    videosGalleryData: {},
  },
  reducers: {
    getTripData: (state, action) => {
      state.data = { ...action.payload }
    },
    postTripData: (state, action) => {
      state.data = { ...action.payload }
    },
    getDetailPageData: (state, action) => {
      state.detailPageData = { ...action.payload }
    },
    flushDetailPageData: (state, action) => {
      state.detailPageData = {}
    },
    getImagesGalleryData: (state, action) => {
      state.imagesGalleryData = { ...action.payload }
    },
    getVideosGalleryData: (state, action) => {
      state.videosGalleryData = { ...action.payload }
    },
    flushImagesGalleryData: (state, action) => {
      state.imagesGalleryData = {}
    },
    flushVideosGalleryData: (state, action) => {
      state.videosGalleryData = {}
    },
  },
})

// action creators
export const {
  getTripData,
  postTripData,
  getDetailPageData,
  flushDetailPageData,
  getImagesGalleryData,
  getVideosGalleryData,
  flushImagesGalleryData,
  flushVideosGalleryData,
} = customerViewSlice.actions

export const fetchCurrentState = (state) => state.tripShow.data
export const fetchDetailPageState = (state) => state.tripShow.detailPageData
export const fetchImagesGallery = (state) => state.tripShow.imagesGalleryData
export const fetchVideosGallery = (state) => state.tripShow.videosGalleryData

export default customerViewSlice.reducer
